/**
 * As rotas antigas de configuração → o endereço novo, dentro da casca.
 *
 * ── Por que gerado, e não escrito à mão
 *
 * Uma lista escrita à mão seria uma **segunda** lista de rotas ao lado do
 * `catalogo.ts`. No dia em que alguém mudasse o destino de um item e esquecesse
 * daqui, o redirect levaria a pessoa para o lugar errado — e nada acusaria,
 * porque as duas listas estariam internamente coerentes.
 *
 * Derivando do catálogo, o redirect não tem como discordar do menu.
 *
 * ── O que NÃO entra
 *
 * Itens cujo destino tem `?aba=` ou `#âncora` ficam de fora **desta leva**: eles
 * ainda não têm painel próprio (ver `itens-registry.tsx`), e redirecionar para
 * um endereço que mostra "ainda abre pela tela antiga" seria trocar uma tela que
 * funciona por um aviso. Entram no K-3, junto com a migração deles.
 *
 * O caminho relativo (sem `/admin/`) é o que o `<Route>` filho de `/admin`
 * espera — daí o `path` sair sem a barra inicial.
 */
import { SECOES_CONFIG } from './catalogo';

export interface RedirectConfig {
  /** Caminho relativo a `/admin` — o formato que o `<Route>` filho usa. */
  de: string;
  /** Endereço novo, absoluto. */
  para: string;
}

/**
 * A fonte é o `rotaAntiga` do item: ele só existe em item que JÁ migrou, e
 * guarda exatamente o endereço que precisa continuar funcionando.
 *
 * Antes eu derivava isto do `para` + uma checagem contra o registry de
 * componentes. Estava errado, e o guarda de destino pegou: depois de migrar, o
 * `para` passa a ser o endereço NOVO — o menu tem que levar direto ao painel, e
 * não passar por um redirect. Derivar o redirect do `para` fazia ele apontar
 * de `/admin/configuracoes/x/y` para `/admin/configuracoes/x/y`.
 */
export const REDIRECTS_CONFIG: RedirectConfig[] = SECOES_CONFIG.flatMap((secao) =>
  secao.itens
    .filter((item): item is typeof item & { rotaAntiga: string } => !!item.rotaAntiga)
    .map((item) => ({
      de: item.rotaAntiga.replace(/^\/admin\//, ''),
      para: item.para,
    })),
);
